import React from "react";
import { TableCell, TableRow, TextField } from "@mui/material";
import { Check, Cancel } from "@mui/icons-material";
import ButtonsAction from "../../components/Tablas/ButtonsAction";
import { butonIconTransition } from "../../../styles/stylesRows";

const inputSx = {
  "& .MuiInputBase-input": { fontSize: "0.7rem", py: 0.3, px: 0.5 },
  "& .MuiFormHelperText-root": { fontSize: "0.55rem", margin: 0 },
};

const RowEditar = ({
  editando,
  setEditando,
  erroresEdit,
  setErroresEdit,
  onGuardar,
  onCancelar,
  guardando,
}) => {
  const handleChange = (field) => (e) => {
    setEditando({ ...editando, [field]: e.target.value });
    if (erroresEdit[field])
      setErroresEdit({ ...erroresEdit, [field]: false });
  };

  return (
    <TableRow
      sx={{
        backgroundColor: "rgba(33, 150, 243, 0.08)",
        height: "1.75rem",
        transition: "background-color 0.5s",
        "& td": {
          fontSize: "0.7rem",
          p: "1px 4px",
          borderBottom: "0.5px solid #ddd",
        },
      }}
    >
      <ButtonsAction
        row={{}}
        botones={[
          {
            tooltip: "Guardar",
            texto: "",
            funcion: onGuardar,
            disabled: guardando,
            Icon: Check,
            color: "success",
            id: 1,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: butonIconTransition,
          },
          {
            tooltip: "Cancelar",
            texto: "",
            funcion: onCancelar,
            disabled: guardando,
            Icon: Cancel,
            color: "error",
            id: 2,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: butonIconTransition,
          },
        ]}
      />
      <TableCell align="left">
        <TextField
          size="small"
          placeholder="Nombre"
          value={editando.imp_nombre}
          onChange={handleChange("imp_nombre")}
          disabled={guardando}
          fullWidth
          error={!!erroresEdit.imp_nombre}
          sx={inputSx}
        />
      </TableCell>
      <TableCell align="left">
        <TextField
          size="small"
          placeholder="Ej. 192.168.1.50"
          value={editando.imp_ip}
          onChange={handleChange("imp_ip")}
          disabled={guardando}
          fullWidth
          error={!!erroresEdit.imp_ip}
          sx={inputSx}
        />
      </TableCell>
    </TableRow>
  );
};

export default React.memo(RowEditar);
